import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../locales/messages";

interface Props {
  connected: boolean;
}

export function ConnectionDot({ connected }: Props) {
  const { t } = useTranslation();
  return (
    <Tooltip title={connected ? t(messages.Live()) : t(messages.Offline())}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: connected ? "#4caf50" : "#bdbdbd",
          boxShadow: connected ? "0 0 4px rgba(76, 175, 80, 0.6)" : "none",
          flexShrink: 0,
        }}
        data-testid="review-connection-dot"
        data-connected={connected ? "true" : "false"}
      />
    </Tooltip>
  );
}
